// Values are backend API strategy names — 'ManualApollo' is the server-side
// identifier for what the UI presents as "Background Import"
export const STORE_REFRESH_STRATEGY_BACKGROUND = 'ManualApollo';
export const STORE_REFRESH_STRATEGY_AUTOMATIC = 'AutomaticOrderSource';
export const STORE_REFRESH_STRATEGY_MANUAL = 'ManualOrderSource';

// Frontend import mode values used for UI state and display logic
export const IMPORT_MODES = {
  Automatic: 'automatic',
  Background: 'background',
  Manual: 'manual',
};
